import http from './api'

const route = 'carrinho/'

export default {
    show: (username, tokencontrato) => {
        return http.post(route + 'showCart', {
            username: username,
            tokencontrato: tokencontrato,
        })
    },

    cartAdd: (carrinho, username, tokencontrato) => {
        return http.post(route + 'cartAdd', {
            carrinho: carrinho,
            username: username,
            tokencontrato: tokencontrato,
        })
    },

    updateItenCart: (produto, tokencontrato) => {
        return http.put(route + 'updateItenCart', {
            produto: produto,
            tokencontrato: tokencontrato,
        })
    },

    updateItemOptionPayment: (opcaoPagamento, tokencontrato, carrinhoId) => {
        return http.post(route + 'updateItemOptionPayment', {
            opcaoPagamento: opcaoPagamento,
            tokencontrato: tokencontrato,
            carrinhoId: carrinhoId,
        })
    },

    addItemCarrinho: (produto, username, tokencontrato) => {
        return http.post(route + 'addItemCarrinho', {
            produto: produto,
            username: username,
            tokencontrato: tokencontrato,
        })
    },
}
